<template>
  <v-app>
    <v-container>
      <v-row v-if="loading || (!code && !receive_id)">
        <v-col cols="12" class="text-center">
          <p>Loading receive details...</p>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="10" offset="1">
          <v-card class="pa-4" id="printable-area">
            <v-row>
              <v-col cols="12">
                <h4 class="d-flex justify-center center" style="color: #333;"><strong>DIRECT RECEIVE</strong></h4>
                <v-row class="justify-space-between">
                  <v-col cols="8">
                    <p style="color: #333;"><strong>SUPPLIER:</strong></p>
                    <p style="color: #555;" class="text-sub-2">{{ supplier?.name || supplier?.supplier_name || 'N/A' }}</p>
                    <p style="color: #555;" class="text-sub-2" v-if="supplier?.address || supplier?.supplier_address">
                      {{ supplier.address || supplier.supplier_address }}
                    </p>
                    <p style="color: #555;" class="text-sub-2" v-if="supplier?.mobile || supplier?.supplier_mobile">
                      <strong>Contact No:</strong> {{ supplier.mobile || supplier.supplier_mobile }}
                    </p>
                    <p style="color: #555;" class="text-sub-2" v-if="supplier?.email || supplier?.supplier_email">
                      <strong>Email:</strong> {{ supplier.email || supplier.supplier_email }}
                    </p>
                  </v-col>
                  <v-col cols="4" class="text-right">
                    <h4 style="font-weight: normal; color: #333;"><strong>RECEIVE # &nbsp;</strong>{{ code }}</h4>
                    <p style="color: #333;" class="text-sub-2"><strong>RECEIVE DATE &nbsp;</strong>{{ formatDateView(receive_date) }}</p>
                    <p style="color: #333;" class="text-sub-2" v-if="shipping_date">
                      <strong>SHIPPING DATE &nbsp;</strong>{{ formatDateView(shipping_date) }}
                    </p>
                    <p style="color: #333;" class="text-sub-2" v-if="warehouse?.name">
                      <strong>WAREHOUSE:</strong> {{ warehouse.name }}
                    </p>
                  </v-col>
                </v-row>
                <v-row v-if="shipping_address" class="mt-2">
                  <v-col cols="12">
                    <p style="color: #555;"><strong>Shipping Address:</strong> {{ shipping_address }}</p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="px-4">
                <br>
              </v-col>
            </v-row>
            <v-table class="mt-1" width="100%">
              <thead>
                <tr>
                  <th style="color: #333;">SN</th>
                  <th style="color: #333;">Code</th>
                  <th style="color: #333;">Item</th>
                  <th class="text-center" style="color: #333;">Quantity</th>
                  <th class="text-center" style="color: #333;">Unit</th>
                  <th class="text-center" style="color: #333;">Rate</th>
                  <th class="text-right" style="color: #333;">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, key) in cart" :key="product.product_id || key">
                  <td style="color: #555;">{{ key + 1 }}</td>
                  <td style="color: #555;">{{ product.product_code || '' }}</td>
                  <td style="color: #555;">{{ product.product_name || '' }}</td>
                  <td class="text-center" style="color: #555;">{{ product.qty || 0 }}</td>
                  <td class="text-center" style="color: #555;">{{ product.unit_name || '' }}</td>
                  <td class="text-center" style="color: #555;">{{ $numberFormat(product.rate || 0) }}</td>
                  <td class="text-right" style="color: #555;">{{ $numberFormat(product.total || (product.qty * product.rate) || 0) }}</td>
                </tr>
                <tr v-if="cart.length === 0">
                  <td colspan="7" class="text-center" style="color: red;">
                    No product details found
                  </td>
                </tr>
              </tbody>
            </v-table>
            <v-row class="py-4">
              <v-col cols="9">
                <p class="text-right " style="color: #555;">TOTAL AMOUNT</p>
                <v-row class=" justify-space-between px-3 py-10">
                  <p colspan="3" style="color: #333;"><strong>Ammount In Words: {{ convertNumberToWords(total_amount || 0) }}</strong></p>
                </v-row>
              </v-col>
              <v-col cols="3">
                <p class="text-right" style="color: #555;">{{ $numberFormat(total_amount || 0) }}</p>
              </v-col>
            </v-row>
            <v-row class="py-5" v-if="remarks">
              <v-col cols="12">
                <p style="color: #555;"><strong>Remarks:</strong> {{ remarks }}</p>
              </v-col>
            </v-row>
            <v-row class="pt-10">
              <v-col cols="4">
                <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                  <span>Receiver's Signature</span>
                </p>
              </v-col>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                  <span>{{ getCurrentCompany?.name || 'Company Name' }}</span>
                </p>
              </v-col>
            </v-row>
            <v-row class="text-center mt-6">
              <v-col cols="12">
                <v-btn color="primary" class="mr-2" @click="printReceive">
                  <v-icon left>mdi-printer</v-icon> Print
                </v-btn>
                <v-btn color="success" @click="downloadReceive(receive_id)">
                  <v-icon left>mdi-file-pdf-box</v-icon> Download PDF
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import convertNumberToWords from "@/plugins/numberToWord";
import formatDateView from "@/plugins/dateFormatView";
import { toast } from "vue3-toastify";
import html2pdf from "html2pdf.js";
import { generatePrintHeaderWithWatermark, generatePrintFooter, getCurrentCompanyForPrint } from "@/utils/printHeader";

export default {
  data() {
    return {
      receive_id: '',
      code: '',
      receive_date: '',
      shipping_date: '',
      shipping_address: '',
      remarks: '',
      total_amount: 0,
      total_item: 0,
      supplier: {},
      warehouse: {},
      cart: [],
      loading: false
    };
  },
  methods: {
    convertNumberToWords,
    formatDateView,

    async downloadReceive(id) {
      try {
        const element = document.getElementById("printable-area");
        if (!element) {
          toast.error("No content to export");
          return;
        }

        const opt = {
          margin: [0.5, 0.5],
          filename: `direct-receive-${this.code || id}.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            logging: false,
            backgroundColor: "#ffffff"
          },
          jsPDF: {
            unit: "cm",
            format: "a4",
            orientation: "portrait"
          }
        };

        await html2pdf().set(opt).from(element).save();
        toast.success("PDF downloaded successfully");
      } catch (error) {
        console.error("PDF generation failed:", error);
        toast.error("Failed to generate PDF");
        // Fallback to print if PDF generation fails
        this.printReceive();
      }
    },
    
    async printReceive() {
      // Get company data using utility function (ensures latest header_image and footer_image from store)
      const currentCompany = getCurrentCompanyForPrint(this.$store);
      
      // Generate header HTML using utility function
      const headerHTML = generatePrintHeaderWithWatermark(
        currentCompany,
        this.getFileServerUrl,
        {
          logoFallback: '@/assets/image/logo.png',
          watermarkOpacity: 0.1
        }
      );
      
      // Generate footer HTML using utility function
      const footerHTML = generatePrintFooter(
        currentCompany,
        this.getFileServerUrl,
        {
          footerStyle: 'margin-top: 30px;'
        }
      );
      
      let printWindow = window.open('', 'PRINT', `width=${screen.width}, height=${screen.height}, left=0, top=0`);
      printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                  <meta charset="UTF-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1.0">
                  <meta http-equiv="X-UA-Compatible" content="ie=edge">
                  <title>Direct Receive</title>
                  <link rel="preconnect" href="https://fonts.googleapis.com">
                  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                  <link href="https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400..700;1,400..700&display=swap" rel="stylesheet">
                  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-sRIl4kxILFvY47J16cr9ZwB07vP4J8+LH7qKQnuqkuIAvNWLzeN8tE5YBujZqJLB" crossorigin="anonymous">
                  <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
                  <style>
                    body {
                      font-family: 'Arimo', sans-serif;
                      margin: 0px;
                      position: relative;
                      min-height: 100vh;
                      padding-bottom: 100px;
                    }
                    .print-footer {
                      position: fixed;
                      bottom: 0;
                      left: 0;
                      right: 0;
                      width: 100%;
                      text-align: center;
                      padding-bottom: 10px;
                      background-color: white;
                    }
                    .invoice-header {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      border-bottom: 2px solid #eee;
                      padding-bottom: 10px;
                    }
                    .invoice-header img {
                      max-height: 70px;
                      max-width: 150px;
                    }
                    .table th, .table td {
                      border: 1px solid #000;
                      padding: 8px;
                      vertical-align: middle;
                    }
                    .table th {
                      background-color: #f0f0f0;
                      color: #333;
                    }
                    .table td {
                      background-color: unset;
                    }
                    .text-end {
                      text-align: right;
                    }
                    .text-center {
                      text-align: center;
                    }
                    h4 {
                      font-size: 20px;
                      color: #333;
                    }
                    p {
                      font-size: 14px;
                      color: #555;
                      margin: 2px 0;
                    }
                    strong {
                      font-weight: bold;
                      color: #333;
                    }
                    .signature-line {
                      border-top: 1px solid #555;
                      width: 200px;
                      margin: 0 auto;
                      text-align: center;
                      color: #333;
                    }
                    @page {
                      // margin: 0in;
                      // size: a4;
                    }
                    @media print {
                      .print-footer {
                        position: fixed;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        width: 100%;
                        page-break-inside: avoid;
                      }
                    }
                    .logo-container {
                      display: flex;
                      align-items: center;
                    }
                    .logo-container img {
                      margin-right: 10px;
                    }
                  </style>
                </head>
                <body>
                  ${headerHTML}
                    <h4 class="text-center my-4"><strong>DIRECT RECEIVE</strong></h4>
                    <div class="row">
                      <div class="col-sm-8">
                        <p><strong>SUPPLIER:</strong></p>
                        <p class="text-sub-2">${this.supplier.name || this.supplier.supplier_name || ''}</p>
                        ${(this.supplier.address || this.supplier.supplier_address) ? `<p class="text-sub-2" style="width:65%">${this.supplier.address || this.supplier.supplier_address}</p>` : ''}
                        ${(this.supplier.mobile || this.supplier.supplier_mobile) ? `<p class="text-sub-2"><strong>Contact No:</strong> ${this.supplier.mobile || this.supplier.supplier_mobile}</p>` : ''}
                        ${(this.supplier.email || this.supplier.supplier_email) ? `<p class="text-sub-2"><strong>Email:</strong> ${this.supplier.email || this.supplier.supplier_email}</p>` : ''}
                      </div>
                      <div class="col-sm-4 text-end">
                        <h4><strong>RECEIVE # ${this.code}</strong></h4>
                        <p class="text-sub-2"><strong>RECEIVE DATE ${this.formatDateView(this.receive_date)}</strong></p>
                        ${this.shipping_date ? `<p class="text-sub-2"><strong>SHIPPING DATE ${this.formatDateView(this.shipping_date)}</strong></p>` : ''}
                        ${this.warehouse.name ? `<p class="text-sub-2"><strong>WAREHOUSE: ${this.warehouse.name}</strong></p>` : ''}
                      </div>
                    </div>
                    ${this.shipping_address ? `
                    <div class="row mt-2">
                      <div class="col-sm-12">
                        <p><strong>Shipping Address:</strong> ${this.shipping_address}</p>
                      </div>
                    </div>
                    ` : ''}
                    <table class="table mt-4">
                      <thead>
                        <tr>
                          <th>SN</th>
                          <th>Code</th>
                          <th>Item</th>
                          <th class="text-center">Quantity</th>
                          <th class="text-center">Unit</th>
                          <th class="text-end">Rate</th>
                          <th class="text-end">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        ${this.cart.map((product, key) => `
                          <tr>
                            <td>${key + 1}</td>
                            <td>${product.product_code || ''}</td>
                            <td>${product.product_name || ''}</td>
                            <td class="text-center">${product.qty || 0}</td>
                            <td class="text-center">${product.unit_name || ''}</td>
                            <td class="text-end">${this.formatNumber(product.rate) || 0}</td>
                            <td class="text-end">${this.formatNumber(product.total || (product.qty * product.rate) || 0)}</td>
                          </tr>
                        `).join('')}
                      </tbody>
                    </table>
                    <div class="row py-4">
                      <div class="col-sm-8">
                        <p class="text-end">TOTAL AMOUNT</p>
                        <p class="text-end"><strong>Ammount In Words: ${this.convertNumberToWords(this.total_amount || 0)}</strong></p>
                      </div>
                      <div class="col-sm-4 text-end">
                        <p><strong>${this.formatNumber(this.total_amount) || 0}</strong></p>
                      </div>
                    </div>
                    ${this.remarks ? `
                    <div class="row py-3">
                      <div class="col-sm-12">
                        <p><strong>Remarks:</strong> ${this.remarks}</p>
                      </div>
                    </div>
                    ` : ''}
                    <div class="row">
                      <div class="col-sm-4 text-center">
                        <p class="signature-line">Receiver's Signature</p>
                      </div>
                      <div class="col-sm-4"></div>
                      <div class="col-sm-4 text-center">
                        <p class="signature-line">${this.getCurrentCompany?.name || 'Company Name'}</p>
                      </div>
                    </div>
                    ${footerHTML}
                  </div>
                </body>
                </html>
              `);
      printWindow.moveTo(0, 0);
      printWindow.focus();
      await new Promise(resolve => setTimeout(resolve, 1000));
      printWindow.print();
      printWindow.close();
    },
    
    formatNumber(value) {
      if (!value) return '0.00';
      return parseFloat(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  computed: {
    getCurrentCompany() {
      return this.$store.getters.getCurrentCompany || {};
    },
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl || '';
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$store.commit("SET_LOADING", { color: "primary" });
      this.$nextTick(() => {
        this.$store
          .dispatch("getInvDirectReceiveById", id)
          .then((data) => {
              this.loading = false;
              let receive = data;
              this.receive_id = receive.id;
              this.code = receive.code || '';
              this.receive_date = receive.receive_date || '';
              this.shipping_date = receive.shipping_date || '';
              this.shipping_address = receive.shipping_address || '';
              this.remarks = receive.remarks || '';
              this.total_amount = receive.amount || 0;
              this.total_item = receive.total_item || 0;

              this.supplier = receive.supplier || {};
              this.warehouse = receive.warehouse || {};

              this.cart = [];
              // Handle both camelCase and snake_case relationship names
              const details = receive.InvDrReceiveDetails || 
                              receive.inv_dr_receive_details || 
                              receive.invDrReceiveDetails || 
                              [];
              details.forEach((item) => {
                  this.cart.push({
                    product_id: item.product_id,
                    product_name: item.product?.name || "",
                    product_code: item.product?.code || "",
                    qty: item.qty || 0,
                    unit_name: item.product?.unit?.name || "",
                    rate: item.rate || 0,
                    total: item.amount || (item.qty * item.rate) || 0,
                  });
              });
              this.$store.commit("UNSET_LOADING");
          })
          .catch((error) => {
              this.loading = false;
              console.error("Failed to fetch direct receive:", error);
              toast.error("Failed to load direct receive details");
              this.$store.commit("UNSET_LOADING");
          });
      });
    } else {
      toast.error("No receive ID provided");
      this.$router.push({ name: "direct-receive-records" });
    }
  },
};
</script>

